import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import './nikke-element.scss';

interface IProps {
  weapon: string;
}

export const NikkeWeapon: React.FC<IProps> = ({ weapon }) => {
  const popoverWeapon = (
    <Popover id="popover-weapon">
      <Popover.Header as="h3">{weapon}</Popover.Header>
      <Popover.Body>
        {weapon === 'Assault Rifle' && (
          <>Well-balanced weapon suitable in all kinds of situations.</>
        )}
        {weapon === 'Minigun' && (
          <>
            Its high ammo capacity and rapid-firing feature make it perfect for
            dealing with swarming enemies.
          </>
        )}
        {weapon === 'Rocket Launcher' && (
          <>
            Deals damage with a wide area of effect, great for attacking groups
            of enemies.
          </>
        )}
        {weapon === 'Shotgun' && (
          <>
            Fires multiple shots at once and ix extremely powerful in close
            range.
          </>
        )}
        {weapon === 'SMG' && (
          <>Its extreme rapid fire makes up for its relatively short range.</>
        )}
        {weapon === 'Sniper Rifle' && (
          <>
            High accuracy shooting from long range makes it perfect for
            targeting specific enemy parts.
          </>
        )}
        {weapon === 'Unknown' && (
          <>
            <>Weapon for this character isn't known yet.</>
          </>
        )}
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="auto-start"
      overlay={popoverWeapon}
    >
      <div className={`nikke-weapon ${weapon}`}>
        {weapon === 'Assault Rifle' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/weapon_ar.png"
              alt={weapon}
            />
            <span>{weapon}</span>
          </>
        )}
        {weapon === 'Minigun' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/weapon_minigun.png"
              alt={weapon}
            />
            <span>{weapon}</span>
          </>
        )}
        {weapon === 'Rocket Launcher' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/weapon_rocket.png"
              alt={weapon}
            />
            <span>{weapon}</span>
          </>
        )}
        {weapon === 'Shotgun' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/weapon_shotgun.png"
              alt={weapon}
            />
            <span>{weapon}</span>
          </>
        )}
        {weapon === 'SMG' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/weapon_smg.png"
              alt={weapon}
            />
            <span>{weapon}</span>
          </>
        )}
        {weapon === 'Sniper Rifle' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/weapon_sniper.png"
              alt={weapon}
            />
            <span>{weapon}</span>
          </>
        )}
        {weapon === 'Unknown' && (
          <>
            <span>{weapon}</span>
          </>
        )}
      </div>
    </OverlayTrigger>
  );
};
